import useMediaQuery from '@material-ui/core/useMediaQuery'
import { Room, Schedule, Today } from '@material-ui/icons'
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api'
import moment from 'moment'
import React from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
  position: relative;
`

const MapDetails = styled.div`
  width: max-content;
  background: var(--map-box-bg);
  border: 1px solid var(--border-color);
  padding: 50px 110px 30px 50px;
  color: var(--dark-text);
  line-height: 1;
  h3 {
    margin: 0 0 20px;
    font-size: 24px;
    font-weight: 700;
  }
  @media only screen and (max-width: 960px) {
    padding: 30px;
    h3 {
      font-size: 18px;
    }
  }
  @media only screen and (max-width: 540px) {
    width: 100%;
    padding: 30px 20px;
    border: none;
  }
`

const DetailItem = styled.div`
  display: flex;
  margin-bottom: 14px;
  font-size: 18px;
  font-weight: 500;
  p {
    margin-top: 8px;
    max-width: 280px;
  }
  a {
    color: ${props => props.color && props.color};
    &:hover {
      opacity: 0.5;
    }
  }
  .MuiSvgIcon-root {
    font-size: 36px;
    color: var(--icon-color);
    margin-right: 28px;
  }
  @media only screen and (max-width: 960px) {
    font-size: 14px;
    p {
      margin-top: 4px;
    }
    .MuiSvgIcon-root {
      font-size: 24px;
    }
  }
  @media only screen and (max-width: 540px) {
    margin-bottom: 2px;
  }
`

const EventInfo = styled.div`
  position: absolute;
  top: 20%;
  right: 8%;
`

const EventInfoSmall = styled.div`
  width: 100%;
`

// biome-ignore lint/suspicious/noShadowRestrictedNames: TODO
const Map = ({ color, date, lat, lng, mapKey, time, venue, allDayEvent }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: mapKey,
  })

  // eslint-disable-next-line prefer-arrow-callback
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  const onLoad = React.useCallback(function onLoad(mapInstance) {})

  const latitude = parseFloat(lat)
  const longitute = parseFloat(lng)

  const desktop = useMediaQuery('(min-width:540px)')

  const renderMap = () => (
    <Wrap>
      {desktop ? (
        <>
          <GoogleMap
            onLoad={onLoad}
            mapContainerStyle={{
              width: '100%',
              height: '560px',
            }}
            zoom={17}
            center={{
              lat: latitude,
              lng: longitute + 0.0019,
            }}
            clickableIcons={false}
            options={{
              disableDefaultUI: true,
              gestureHandling: 'none',
              zoomControl: true,
            }}
            id="map"
          >
            <Marker
              position={{
                lat: latitude,
                lng: longitute,
              }}
            />
          </GoogleMap>
          <EventInfo>
            <MapDetails>
              <h3>Key Details</h3>
              {time && !allDayEvent && (
                <DetailItem>
                  <Schedule />
                  <p>{time}</p>
                </DetailItem>
              )}
              {date && (
                <DetailItem>
                  <Today />
                  <p>{moment(date).format('Do MMMM, YYYY')}</p>
                </DetailItem>
              )}
              {venue.street ? (
                <DetailItem color={color}>
                  <Room />
                  <span>
                    <p>{venue.name}</p>
                    <p>
                      <a
                        href={`https://maps.google.com/?q=${venue.street},+${venue.city},+${venue.state},+${venue.postcode},+${venue.country}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {venue.street}, {venue.city}, {venue.state}, {venue.postcode}, {venue.country}
                      </a>
                    </p>
                  </span>
                </DetailItem>
              ) : null}
            </MapDetails>
          </EventInfo>
        </>
      ) : (
        <>
          <EventInfoSmall>
            <MapDetails>
              <h3>Key Details</h3>
              {time && !allDayEvent && (
                <DetailItem>
                  <Schedule />
                  <p>{time}</p>
                </DetailItem>
              )}
              {date && (
                <DetailItem>
                  <Today />
                  <p>{moment(date).format('Do MMMM, YYYY')}</p>
                </DetailItem>
              )}
              {venue && (
                <DetailItem color={color}>
                  <Room />
                  <span>
                    <p>{venue.name}</p>
                    <p>
                      <a
                        href={`https://maps.google.com/?q=${venue.street},+${venue.city},+${venue.state},+${venue.postcode},+${venue.country}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {venue.street}, {venue.city}, {venue.state}, {venue.postcode}, {venue.country}
                      </a>
                    </p>
                  </span>
                </DetailItem>
              )}
            </MapDetails>
          </EventInfoSmall>
          <GoogleMap
            onLoad={onLoad}
            mapContainerStyle={{
              width: '100%',
              height: '220px',
            }}
            zoom={17}
            center={{
              lat: latitude,
              lng: longitute,
            }}
            clickableIcons={false}
            options={{
              disableDefaultUI: true,
              gestureHandling: 'none',
              zoomControl: false,
            }}
            id="map"
          >
            <Marker
              position={{
                lat: latitude,
                lng: longitute,
              }}
            />
          </GoogleMap>
        </>
      )}
    </Wrap>
  )

  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>
  }

  return isLoaded ? renderMap() : 'Loading'
}

export default Map
